import { createAction } from "@reduxjs/toolkit";
import { fleetManagerContextTypes } from "../../context/store/actions/fleetManagerContext.types";

export const toggleShowEntryRightInvitationFormAction = createAction
    (fleetManagerContextTypes.TOGGLE_SHOW_ENTRY_RIGHT_INVITATION_FORM);

export const togglePedestrianDelegeeEditFormAction = createAction<{ delegeeId: string } >
    (fleetManagerContextTypes.TOGGLE_EDIT_PEDESTRIAN_DELEGEE_FORM);